import React, { useEffect, useState } from 'react';
import classes from "./PredictionGame.module.css";
import { FaArrowLeft, FaCircle, FaMinus } from 'react-icons/fa6';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from "moment-timezone";
import { getPredictionLeaderboardApi, getUserPredictionsApi, matchDetailsApi } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
import Layout from '../component/Layout';
import SubLayout from '../component/SubLayout';
import Container from '../component/Container';
import { Panel } from 'primereact/panel';
import MatchEvents from '../component/MatchEvents';
import SmallLoader from '../component/SmallLoader';
import { removeUserDetails } from '../store/slices/userSlice';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const PredictionGame = () => {

    const location = useLocation();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [matchDetails, setMatchDetails] = useState(null);
    const [matchDetails2, setMatchDetails2] = useState(null);
    const [predictions, setPredictions] = useState([]);
    const { userDetails } = useSelector(state => state?.persisted?.userSlice);
    const [time, setTime] = useState(null);
    const [display, setDisplay] = useState("block");
    const [tab, setTab] = useState("mypredictions");

    const { selectedLanguage } = useSelector(state => state.languageSlice);

    const [loading, setLoading] = useState(true);
    const [loader, setLoader] = useState(true);

    const [leaderboard, setLeaderboard] = useState([]);
    const [userRank, setUserRank] = useState(null);

    const dispatch = useDispatch();

    const fetchMatchDetails = async () => {
        try {
            const response = await matchDetailsApi(location?.state?.match_fixture_id, userDetails?.token);
            setMatchDetails(response?.data);
            if (response?.data?.match_details) {
                setMatchDetails2(JSON.parse(response?.data?.match_details));
            }
        } catch (error) {
            console.log(error, 'error---');

            if (error?.response?.status == 403) {
                dispatch(removeUserDetails());
                toast.error(t("129"));
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.message || error?.response?.message || error?.data?.message || t("128"));
                console.log(error, 'error---');
            }
        }
    }

    const fetchUserPredictions = async () => {
        try {
            const response = await getUserPredictionsApi(location?.state?.match_fixture_id, userDetails?.token);
            setPredictions(JSON.parse(response?.data?.[0].predictions));
        } catch (error) {
            console.log(error, 'error---');
        }
    }

    const fetchLeaderboard = async () => {
        try {
            const response = await getPredictionLeaderboardApi(location?.state?.match_fixture_id, userDetails?.token);
            setLeaderboard(response?.data?.leaderboard);
            setUserRank(response?.data?.userRank?.[0]);
        } catch (error) {
            console.log(error, 'error---');
        }
    }

    const fetchData = async (load) => {
        if (load) {
            setLoading(true);
        }
        setLoader(true);
        fetchMatchDetails(load);
        fetchUserPredictions(load);
        fetchLeaderboard(load);
        setLoading(false);
        setLoader(false);
    }

    useEffect(() => {
        if (location?.state?.match_fixture_id) {
            fetchData(true);
        }
        else {
            navigate("/home");
        }
    }, [location?.state?.match_fixture_id]);

    useEffect(() => {
        if (!loader) {
            const intervalId = setInterval(() => {
                if (!document.hidden) {
                    fetchData(false);
                }
            }, 10000);
            return () => clearInterval(intervalId);
        }

    }, [loader]);

    const matchTimer = (match_date_time) => {
        try {
            const liveTime = moment();
            const matchTime = moment.utc(match_date_time);
            const timeLeft = moment.duration(matchTime.diff(liveTime));

            if (timeLeft.asMilliseconds() <= 0) {
                console.log("Match has already started.");
                setDisplay("none");
            }
            const hours = Math.floor(timeLeft.asHours());
            const minutes = timeLeft.minutes();
            const seconds = timeLeft.seconds();

            console.log(`Match starts in ${hours}h ${minutes}m ${seconds}s`);
            // return `${hours}h ${minutes}m ${seconds}s`;
            setTime(`${hours}h ${minutes}m ${seconds}s`);
            // setExpireTime(`${hours}h ${minutes}m ${seconds}s`)
        } catch (error) {
            console.log(error, 'errro--');
        }
    }

    useEffect(() => {
        if (matchDetails?.match_status == "NS" && display != "none") {
            const intervalId = setInterval(() => {
                matchTimer(matchDetails?.match_date_time);
            }, 1000);

            return () => {
                clearInterval(intervalId);
            }
        }

    }, [matchDetails, display]);

    return (
        <>
            <Layout>
                <SubLayout>
                    {loading ? <SmallLoader
                        style={{ minHeight: "80dvh", display: "flex", justifyContent: "center", alignItem: "center" }}
                    /> : (
                        <>
                            <div className={classes.header}>
                                <div className={classes.header_nav}>
                                    <div className={classes.header_nav_container}>
                                        <button type='button' className={classes.back_button}>
                                            <FaArrowLeft className={classes.back_icon} onClick={() => navigate("/home")} />
                                        </button>
                                    </div>
                                </div>

                                <div className={classes.match_details_container}>

                                    {
                                        // matchDetails?.match_status == "NS" ? (
                                        //     <div className={classes.match_status}>
                                        //         <p className={classes.status_text}>Not Started Yet</p>
                                        //     </div>
                                        // ) :
                                        matchDetails?.match_status == "FT" ? (
                                            <div className={classes.match_status}>
                                                <p className={classes.status_text}>FT</p>
                                            </div>
                                        ) :
                                            matchDetails?.match_status == "AET" ? (
                                                <div className={classes.match_status}>
                                                    <p className={classes.status_text}>{t("56")}</p>
                                                </div>
                                            ) : matchDetails?.match_status == "PEN" ? (
                                                <div className={classes.match_status}>
                                                    <p className={classes.status_text}>{t("56")}</p>
                                                </div>
                                            ) : matchDetails?.match_status == "SUSP" ? (
                                                <div className={classes.match_status}>
                                                    <p className={classes.status_text}>{t("57")}</p>
                                                </div>
                                            ) :
                                                matchDetails?.match_status == "PST" ? (
                                                    <div className={classes.match_status}>
                                                        <p className={classes.status_text}>{t("58")}</p>
                                                    </div>
                                                ) :
                                                    matchDetails?.match_status == "CANC" ? (
                                                        <div className={classes.match_status}>
                                                            <p className={classes.status_text}>{t("59")}</p>
                                                        </div>
                                                    ) :
                                                        matchDetails?.match_status == "ABD" ? (
                                                            <div className={classes.match_status}>
                                                                <p className={classes.status_text}>{t("60")}</p>
                                                            </div>
                                                        ) :
                                                            (matchDetails?.match_status == "AWD" || matchDetails?.match_status == "WO") ? (
                                                                <div className={classes.match_status}>
                                                                    <p className={classes.status_text}>{t("60")}</p>
                                                                </div>
                                                            ) :
                                                                (matchDetails?.match_status == "1H" || matchDetails?.status == "LIVE") ?
                                                                    (
                                                                        <div className={classes.match_status}>
                                                                            <p className={classes.status_text}>
                                                                                <FaCircle className={`${classes.text_danger_glow} ${classes.blink}`}
                                                                                    style={{ fontSize: "8px" }}
                                                                                />
                                                                                <span style={{ marginLeft: "6px" }}>
                                                                                    <>{matchDetails2?.fixture?.status?.elapsed}`</>
                                                                                </span>
                                                                            </p>
                                                                        </div>
                                                                    ) :
                                                                    matchDetails?.match_status == "HT" ?
                                                                        (
                                                                            <div className={classes.match_status}>
                                                                                <p className={classes.status_text}>
                                                                                    <FaCircle className={`${classes.text_danger_glow} ${classes.blink}`}
                                                                                        style={{ fontSize: "8px" }}
                                                                                    />
                                                                                    <span style={{ marginLeft: "6px" }}>
                                                                                        {t("61")}{" "}<>{matchDetails2?.fixture?.status?.elapsed}`</>
                                                                                    </span>
                                                                                </p>
                                                                            </div>
                                                                        ) : matchDetails?.match_status == "2H" ?
                                                                            (
                                                                                <div className={classes.match_status}>
                                                                                    <p className={classes.status_text}>
                                                                                        <FaCircle className={`${classes.text_danger_glow} ${classes.blink}`}
                                                                                            style={{ fontSize: "8px" }}
                                                                                        />
                                                                                        <span style={{ marginLeft: "6px" }}>
                                                                                            <>{matchDetails2?.fixture?.status?.elapsed}`</>
                                                                                        </span>
                                                                                    </p>
                                                                                </div>
                                                                            ) : matchDetails?.match_status == "ET" ?
                                                                                (
                                                                                    <div className={classes.match_status}>
                                                                                        <p className={classes.status_text}>
                                                                                            <FaCircle className={`${classes.text_danger_glow} ${classes.blink}`}
                                                                                                style={{ fontSize: "8px" }}
                                                                                            />
                                                                                            <span style={{ marginLeft: "6px" }}>
                                                                                                <>{matchDetails2?.fixture?.status?.elapsed}`</>{" "} {t("62")} {matchDetails2?.fixture?.status?.extra}`
                                                                                            </span>
                                                                                        </p>
                                                                                    </div>
                                                                                ) : matchDetails?.match_status == "P" ?
                                                                                    (
                                                                                        <div className={classes.match_status}>
                                                                                            <p className={classes.status_text}>
                                                                                                <FaCircle className={`${classes.text_danger_glow} ${classes.blink}`}
                                                                                                    style={{ fontSize: "8px" }}
                                                                                                />
                                                                                                <span style={{ marginLeft: "6px" }}>
                                                                                                    {t("63")}{" "}<>{matchDetails2?.fixture?.status?.elapsed}`</>
                                                                                                </span>
                                                                                            </p>
                                                                                        </div>
                                                                                    ) : null}

                                    <div className={classes.match_details}>
                                        <div className={classes.team}>
                                            <img src={matchDetails?.home_team_image} alt={matchDetails?.home_team_name} className={classes.team_logo} />
                                            <p className={classes.team_name}>{matchDetails?.home_team_name}</p>
                                        </div>
                                        <div className={classes.score_container}>
                                            <p className={classes.score}>
                                                {matchDetails2?.goals?.home}
                                            </p>
                                            <div className={classes.separator}>
                                                <FaMinus className={classes.separator_icon} />
                                            </div>
                                            <p className={classes.score}>
                                                {matchDetails2?.goals?.away}
                                            </p>
                                        </div>
                                        <div className={classes.team}>
                                            <img src={matchDetails?.away_team_image} alt={matchDetails?.away_team_name} className={classes.team_logo} />
                                            <p className={classes.team_name}>{matchDetails?.away_team_name}</p>
                                        </div>
                                    </div>

                                    {matchDetails?.match_status == "NS" &&
                                        <div className={classes.match_timer_container} style={{ display }}>
                                            <p className={classes.match_timer}>
                                                {time}
                                            </p>
                                        </div>
                                    }

                                    <p className={classes.match_time} style={{ paddingTop: "10px" }}>
                                        {moment.utc(matchDetails?.match_date_time).local().format("dddd, DD MMM YYYY [at] hh:mm A")}
                                    </p>
                                </div>



                                <div className={classes.tabs_container}>
                                    <button type='button' className={`${classes.tab_option} ${tab === "mypredictions" && classes.active}`}
                                        onClick={() => setTab("mypredictions")}
                                    >
                                        {t("164")}
                                    </button>
                                    <button type="button" className={`${classes.tab_option} ${tab === "leaderboard" && classes.active}`}
                                        onClick={() => setTab("leaderboard")}

                                    >
                                        {t("65")}
                                    </button>
                                    <button type="button" className={`${classes.tab_option} ${tab === "events" && classes.active}`}
                                        onClick={() => setTab("events")}

                                    >
                                        {t("66")}
                                    </button>
                                </div>
                            </div>

                            <Container>
                                {/* HERE WE WILL SHOW THE USER THE DETAILS OF THE PREDICTIONS... */}

                                {tab == "mypredictions" ?
                                    <>
                                        {
                                            predictions.length > 0 &&
                                            predictions.map((prediction, index) => {
                                                const [key, value] = Object.entries(prediction)[0];
                                                console.log({ key, value });

                                                if (key == "prediction4") {
                                                    return (
                                                        <div
                                                            className={classes.question}
                                                            key={index}
                                                        >
                                                            <p className={classes.question_title}>
                                                                {/* {value?.[0]?.question} */}
                                                                {selectedLanguage == 0 ? value?.[0]?.question : value?.[0]?.question_name}
                                                            </p>

                                                            <div className={classes.answer_container}>
                                                                <p className={classes.answer}>{value?.[0]?.answer}</p>
                                                            </div>

                                                            <div className={classes.answer_container}>
                                                                <p className={classes.answer}>{value?.[1]?.answer}</p>
                                                            </div>

                                                            {value?.[0].message != "" && (
                                                                <>
                                                                    <div className={classes.message_container}>
                                                                        <p className={classes.message}>
                                                                            {selectedLanguage == 0 ? value?.[0]?.message : value?.[0]?.message_sw}
                                                                            {/* {value?.[0]?.message} */}
                                                                        </p>
                                                                        <div className={classes.points_container}>
                                                                            <p className={classes.point}>
                                                                                {t("88")} {value?.[0].point + value?.[1]?.point}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                            }

                                                        </div>
                                                    )
                                                }

                                                else if (key == "prediction7") {
                                                    return (
                                                        <div
                                                            className={classes.question}
                                                            key={index}
                                                        >
                                                            <p className={classes.question_title}>
                                                                {/* {value?.[0]?.question} */}
                                                                {selectedLanguage == 0 ? value?.[0]?.question : value?.[0]?.question_sw}
                                                            </p>

                                                            <div className={classes.answer_container}>
                                                                <p className={classes.answer}>{value?.[0]?.answer}</p>
                                                            </div>

                                                            <div className={classes.answer_container}>
                                                                <p className={classes.answer}>{value?.[1]?.answer}</p>
                                                            </div>

                                                            {value?.[0].message != "" && (
                                                                <>
                                                                    <div className={classes.message_container}>
                                                                        <p className={classes.message}>
                                                                            {/* {value?.[0]?.message} */}
                                                                            {selectedLanguage == 0 ? value?.[0]?.message : value?.[0]?.message_sw}
                                                                        </p>
                                                                        <div className={classes.points_container}>
                                                                            <p className={classes.point}>
                                                                                {t("88")} {value?.[0].point + value?.[1]?.point}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                            }

                                                        </div>
                                                    )
                                                }

                                                else if (key == "prediction8") {
                                                    return (
                                                        <div
                                                            className={classes.question}
                                                            key={index}
                                                        >
                                                            <p className={classes.question_title}>
                                                                {/* {value?.[0]?.question} */}
                                                                {selectedLanguage == 0 ? value?.[0]?.question : value?.[0]?.question_sw}
                                                            </p>

                                                            <div className={classes.answer_container}>
                                                                <p className={classes.answer}>{value?.[0]?.answer}</p>
                                                            </div>

                                                            <div className={classes.answer_container}>
                                                                <p className={classes.answer}>{value?.[1]?.answer}</p>
                                                            </div>

                                                            {value?.[0].message != "" && (
                                                                <>
                                                                    <div className={classes.message_container}>
                                                                        <p className={classes.message}>
                                                                            {/* {value?.[0]?.message} */}
                                                                            {selectedLanguage == 0 ? value?.[0]?.message : value?.[0]?.message_sw}
                                                                        </p>
                                                                        <div className={classes.points_container}>
                                                                            <p className={classes.point}>
                                                                                {t("88")} {value?.[0].point + value?.[1]?.point}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                            }

                                                        </div>
                                                    )
                                                }
                                                else {

                                                    return (
                                                        <div
                                                            className={classes.question}
                                                            key={index}
                                                        >
                                                            <p className={classes.question_title}>
                                                                {/* {value?.question} */}
                                                                {selectedLanguage == 0 ? value?.question : value?.question_sw}
                                                            </p>

                                                            <div className={classes.answer_container}>
                                                                <p className={classes.answer}>{value?.answer}</p>
                                                            </div>

                                                            {value?.message != "" && (
                                                                <>
                                                                    <div className={classes.message_container}>
                                                                        <p className={classes.message}>
                                                                            {/* {value?.message} */}
                                                                            {selectedLanguage==0 ? value?.message : value?.message_sw}
                                                                        </p>
                                                                        <div className={classes.points_container}>
                                                                            <p className={classes.point}>
                                                                                {t("88")} {value?.point}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                            }
                                                        </div>
                                                    );
                                                }
                                            })



                                        }

                                        {matchDetails?.match_status == "NS" &&
                                            <div className={classes.edit_button_container}>
                                                <button type='button' className={classes.edit_button}
                                                    onClick={() => navigate("/create-prediction", {
                                                        state: {
                                                            match_fixture_id: matchDetails?.match_fixture_id,
                                                            edit: true
                                                        }
                                                    }
                                                    )}
                                                >
                                                    {t("165")}
                                                </button>
                                            </div>
                                        }
                                    </>

                                    : tab === "events" ? (

                                        <div className={classes.grid_col_2}>
                                            <MatchEvents
                                                team_name={matchDetails?.home_team_name}
                                                data={matchDetails2?.events?.filter((data) => {
                                                    return (
                                                        data?.team?.name == matchDetails?.home_team_name &&
                                                        data?.type == "Goal" &&
                                                        data?.detail != "Missed Penalty"
                                                    );
                                                })}
                                            />
                                            <MatchEvents
                                                team_name={matchDetails?.away_team_name}
                                                data={matchDetails2?.events?.filter((data) => {
                                                    return (
                                                        data?.team?.name == matchDetails?.away_team_name &&
                                                        data?.type == "Goal" &&
                                                        data?.detail != "Missed Penalty"
                                                    );
                                                })}
                                            />
                                        </div>

                                    ) : tab === "leaderboard" ? (
                                        <div className={classes.leaderboard_container}>

                                            {/* HERE SHOW USER RANK + POINTS... */}

                                            <div className={classes.headings}>
                                                <div className={classes.rank_heading}>
                                                    {t("112")}
                                                </div>
                                                <div className={classes.number_heading}>
                                                    {t("113")}
                                                </div>
                                                <div className={classes.points_heading}>
                                                    {t("70")}
                                                </div>
                                            </div>
                                            {leaderboard?.map((data, index) => {
                                                return (
                                                    <div className={classes.leaderboard_data} key={index}>
                                                        <div className={classes.rank_data}>
                                                            {data?.rank}
                                                        </div>
                                                        <div className={classes.number_data}>
                                                            {data?.msisdn}
                                                        </div>
                                                        <div className={classes.points_data}>
                                                            {data?.total_points}
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    ) : null}

                            </Container>
                        </>
                    )}


                </SubLayout>
            </Layout>
        </>
    )
}

export default PredictionGame